import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GAME_HISTORY_FEATURE_KEY,
  GameHistoryState,
  gameHistoryAdapter,
} from './game-history.reducer';

// Lookup the 'GameHistory' feature state managed by NgRx
export const getGameHistoryState = createFeatureSelector<GameHistoryState>(
  GAME_HISTORY_FEATURE_KEY,
);

const { selectAll, selectEntities } = gameHistoryAdapter.getSelectors();

export const getGameHistoryLoaded = createSelector(
  getGameHistoryState,
  (state: GameHistoryState) => state.loaded,
);

export const getGameHistoryError = createSelector(
  getGameHistoryState,
  (state: GameHistoryState) => state.error,
);

export const getAllGameHistory = createSelector(
  getGameHistoryState,
  (state: GameHistoryState) => selectAll(state),
);

export const getGameHistoryEntities = createSelector(
  getGameHistoryState,
  (state: GameHistoryState) => selectEntities(state),
);

export const getGameHistorySelectedId = createSelector(
  getGameHistoryState,
  (state: GameHistoryState) => state.selectedId,
);
export const getGameHistoryTotal = createSelector(
  getGameHistoryState,
  (state: GameHistoryState) => state.total || 0,
);

export const getGameHistorySelected = createSelector(
  getGameHistoryEntities,
  getGameHistorySelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : []),
);
